import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const cseListItem = {
  itemGap: css`var(--cse-list-item-gap, ${csSpacing.spacing05})`,
  bulletSize: css`var(--cse-list-bullet-size, ${csSpacing.spacing03})`,
  iconColor: css`var(--cse-list-icon-color, ${csColorText.body})`,
  itemJustifyContent: css`var(--cse-list-item-justify-content, normal)`
}

export const style: CSSResult = css`
  .item {
    align-items: center;
    display: flex;
    gap: ${cseListItem.itemGap};
    justify-content: ${cseListItem.itemJustifyContent};
  }

  .bullet, .custom-icon {
    color: ${cseListItem.iconColor};
  }

  .bullet {
    font-size: ${cseListItem.bulletSize};
  }
`
